import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthenticationService } from '../core/services/Authentication/authentication.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const authenticationService = inject(AuthenticationService);
    const authToken = authenticationService.getsession(); // e.g., from localStorage
    console.log("authToken");
    

    if (authToken) {
        const cloned = req.clone({
            setHeaders: {
                Authorization: `Bearer ${authToken}`, // or your custom key
            },
        });
        return next(cloned);

    }

    return next(req);
};
